import { render, staticRenderFns } from "./WasteCollectionView.vue?vue&type=template&id=5a7a4f15&"
import script from "./WasteCollectionView.vue?vue&type=script&lang=js&"
export * from "./WasteCollectionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports